<template>
  <v-form @submit.prevent="createAttCorrections" ref="form">
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">Attendance Corrections</span>
            <v-spacer></v-spacer>
            <help-link appId="attendance" pageId="attendance-corrections" color="black"></help-link>
            <v-btn icon @click.native="closeDialog" :disabled="disabled" title="Close">
                X
            </v-btn>
        </v-toolbar>
        <v-card-text dense>
            <v-alert v-if="attCorrectionsStatus==commonfn.getStatusCode('Approved')" :value="true" color="warning" icon="warning" outline style="margin:-20px 20px 10px 20px;">
                This is already approved. Clicking Save will update back to For Review.
            </v-alert>  
            <p v-if="error" style="color:red;">{{ errorMessage }}</p>
            <v-layout row wrap>
                <v-flex xs12 sm12 style="padding:10px 25px 0px 25px;" >  
                    <v-layout row>  
                        <v-flex xs3>
                            Trans Date:
                        </v-flex> 
                        <v-flex xs9>
                            {{transDate | moment('YYYY-MM-DD (dddd)')}}
                        </v-flex>      
                    </v-layout>
                    <v-layout row style="margin-top:20px;">  
                        <v-flex xs3>
                            Work Shift:
                        </v-flex> 
                        <v-flex xs9>
                            {{workShift}}
                        </v-flex>      
                    </v-layout>

                    <!--Clock start-->
                    <v-layout row>  
                        <v-flex xs3 style="margin-top:25px;">
                            Clock-In:
                        </v-flex>
                        <v-flex xs9 style="margin-top:-5px;">
                            <div>
                                <v-menu
                                    ref="menuClockStart"
                                    v-model="menuClockStart"
                                    :close-on-content-click="false"
                                    :return-value.sync="timeClockStart"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="timeClockStart"
                                        readonly
                                        v-on="on"
                                        :rules="[rules.required]" 
                                    ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="menuClockStart"
                                        v-model="timeClockStart"
                                        full-width
                                        @click:minute="$refs.menuClockStart.save(timeClockStart)"
                                        :allowed-hours="allowedHoursStart"
                                        scrollable
                                        format="24hr"
                                    ></v-time-picker>
                                </v-menu>
                            </div>
                        </v-flex>
                    </v-layout>
                    <!--end: Clock start-->

                    <!--Clock End-->        
                    <v-layout row>  
                    <v-flex xs3 style="margin-top:5px;">
                            Clock-Out:
                        </v-flex>
                        <v-flex xs9 style="margin-top:-25px;">
                            <div>
                                <v-menu
                                    ref="menuClockEnd"
                                    v-model="menuClockEnd"
                                    :close-on-content-click="false"
                                    :return-value.sync="timeClockEnd"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="timeClockEnd"
                                        readonly
                                        v-on="on"
                                        :rules="[rules.required]" 
                                    ></v-text-field>
                                    </template>
                                    <v-time-picker
                                    v-if="menuClockEnd"
                                        v-model="timeClockEnd"
                                        full-width
                                        @click:minute="$refs.menuClockEnd.save(timeClockEnd)"
                                        :allowed-hours="allowedHoursEnd"
                                        scrollable
                                        format="24hr"
                                    ></v-time-picker>
                                </v-menu>
                            </div>    
                        </v-flex>
                    </v-layout> 
                    <!--end: Clock End-->

                    <v-layout row style="margin:10px 0px -20px 0px;">  
                        <v-flex xs12>
                            <v-textarea v-model="remarks" 
                                :rules="[rules.required]"
                                maxlength="150"
                                hint="150 characters max"
                                outline label="Comments" rows="2" color="primary"></v-textarea>
                        </v-flex>      
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions style="height:45px">
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="loading">
                <span v-if="mode=='Add'">Save</span>
                <span v-if="mode=='Edit'">Update</span>
            </v-btn>
            <v-btn v-if="mode=='Add'" @click="clearForm" :disabled="disabled" >Clear</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

import attCorrectionsApi from '@/api/attendancecorrection'
import commonfn from '@/common/functions'

export default {
    data() {
        return {
            error: false,
            errorMessage: '',
            transDate: '',
            workShift: '',
            disabled: false,
            loading: false,
            rules: {
                    required: value => !!value || 'Required.',
                    min: v => v.length >= 8 || 'Min 8 characters',
                },
            menuClockStart: false,
            timeClockStart: null,
            menuClockEnd: false,
            timeClockEnd: null,
            startDate: new Date().toISOString().substr(0, 10),
            menuStartDate: false,
            endDate: new Date().toISOString().substr(0, 10),
            menuEndDate: false,
            remarks: '',
            mode: '',
            approved: false,
            attCorrectionsStatus: '',
            attendanceCorrectionsId: '',
            updatedBy: '',
            updatedByName: '',
            updatedByRemarks: '',
            updatedOn: '',
            workshiftClockStart: null,
            workshiftClockEnd: null,
            maxMinAllowedHours: 2   //allow attendance correction clock-in/out greater than or less than 2hours and 59secs
                                    //this can be set as company settings if requested
        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {
        allowedHoursStart(hour) {
            const lowerBound = (this.workshiftClockStart - this.maxMinAllowedHours + 24) % 24;
            const upperBound = (this.workshiftClockStart + this.maxMinAllowedHours + 24) % 24;

            if (lowerBound > upperBound) {
                // Handle wraparound case
                return hour >= lowerBound || hour <= upperBound;
            } else {
                return hour >= lowerBound && hour <= upperBound;
            }
        },
        allowedHoursEnd(hour) {
            const lowerBound = (this.workshiftClockEnd - this.maxMinAllowedHours + 24) % 24;
            const upperBound = (this.workshiftClockEnd + this.maxMinAllowedHours + 24) % 24;

            if (lowerBound > upperBound) {
                // Handle wraparound case
                return hour >= lowerBound || hour <= upperBound;
            } else {
                return hour >= lowerBound && hour <= upperBound;
            }
        },
        setParams(data) { 
            this.mode = data.mode
            this.transDate = data.transDate
            this.workShift = data.workshift
            this.attendanceCorrectionsId = data.attendanceCorrectionsId
            this.attCorrectionsStatus = data.attCorrectionsStatus 
            this.workshiftClockStart = parseInt(this.$moment(data.clockStart).format('H'))
            this.workshiftClockEnd = parseInt(this.$moment(data.clockEnd).format('H'))

            if (data.mode == 'Edit') {
                this.timeClockStart = this.$moment(data.clockIn).format('H:mm')
                this.timeClockEnd = this.$moment(data.clockOut).format('H:mm')
                this.remarks = data.remarks 
                this.updatedBy = data.updatedBy 
                this.updatedByName = data.updatedByName 
                this.updatedByRemarks = data.updatedByRemarks 
                this.updatedOn = data.updatedOn 
            }else{
                this.timeClockStart = this.$moment(data.clockStart).format('H:mm')
                this.timeClockEnd = this.$moment(data.clockEnd).format('H:mm')
            }
        },
        async deleteAttCorrections() {
            try{
               
                this.loading = true
                this.disabled = true

                const data = {
                    attendanceCorrectionsId : this.attendanceCorrectionsId
                }
                const response = await attCorrectionsApi.delete(data)

                if (response && response.status == 200) {
                    this.clearForm()
                    this.$emit('send',null)
                }

                this.loading = false
                this.disabled = false
            
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async createAttCorrections() {
            try{
                if (this.$refs.form.validate()) {
                    this.loading = true
                    this.disabled = true

                    const data = {    
                        attendanceCorrectionsId : this.attendanceCorrectionsId,                    
                        transDate : this.transDate,
                        clockIn : this.timeClockStart,
                        clockOut: this.timeClockEnd,
                        remarks: this.remarks
                    }
                    var response = null
                    
                    if (this.mode == 'Add')
                        response = await attCorrectionsApi.add(data)
                    else
                        response = await attCorrectionsApi.update(data)

                    if (response && response.status == 200) {
                        this.clearForm()
                        this.$emit('send',null)
                    }

                    this.loading = false
                    this.disabled = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        },
        closeDialog() {
            this.$emit('update:dialogAttendanceCorrections', false)
        }
    },
    created() {
        this.commonfn = commonfn
    }
}
</script>